import { ProcessedBlock } from '/types';

const isNotProductBlock = (block: ProcessedBlock): boolean =>
  !['product', 'media'].includes(block.json.columns?.list[0]?.name || '');

// Blocks marked xfer-block-wall-of-text in the lfe sometimes have
// type block-product-wall-analyst in the json but have block-content shape
export const fixBlockWallOfText = (block: ProcessedBlock): void => {
  if (
    block?.html?.includes('xfer-block-wall-of-text') &&
    block.type === 'block-product-wall-analyst' &&
    isNotProductBlock(block)
  ) {
    block.type = 'xfer-block-wall-of-text';
  }
};

// CMS sometimes sends 'bg-white' etc when there is a bg image
export const fixBackgroundType = (block: ProcessedBlock): void => {
  block.background_type =
    block?.background_id &&
    ['bg-white', 'bg-black', 'bg-grey'].includes(block['background_type'])
      ? 'bg-image'
      : block['background_type'];
};

// Fallback to 'block-content' when the block type is missing
export const fixMissingType = (block: ProcessedBlock): void => {
  if (block.type === undefined) {
    block.type = 'block-content';
  }
};
